var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotifyInfo)?_c('div',{staticClass:"renewal-warning"},[_c('img',{attrs:{"src":require('@/assets/img/renewal_notice.png'),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.notifyInfo))]),_c('p',{staticClass:"btn",on:{"click":_vm.jumpRenewPage}},[_vm._v("立即续费")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }